import { useCompoundBody } from "@react-three/cannon"
import { useRef } from "react"
import { Group } from "three"
import { Box, Cylinder, ObjectProps, Sphere } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 100,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { args: [8, 19, 0.5], mass: 1, position: [0, 0, 0], type: 'Box', rotation: [0, Math.PI / 2, 0] },
      { args: [0.1, 0.1, 0.6], mass: 0.1, position: [-0.25, 0, -3], type: 'Cylinder', rotation: [0, 0, Math.PI / 2] },
      { args: [0.3], mass: 0.1, position: [-0.75, 0, -3], type: 'Sphere' },

      { args: [0.5, 0.5, 2], mass: 0.1, position: [0, 4, 4], type: 'Cylinder', },
      { args: [0.5, 0.5, 2], mass: 0.1, position: [0, -4, 4], type: 'Cylinder', },
    ], 
    type: 'Static',
  }), useRef<Group>(null));
  return (
    <group ref={ref} dispose={null}>
      <Box position={[0, 0, 0]} args={[8, 19, 0.5]} rotation={[0, Math.PI / 2, 0]} />

      <Cylinder position={[-0.25, 0, -3]} rotation={[0, 0, Math.PI / 2]} args={[0.1, 0.1, 0.6, 8]} color="#2a2a2a" />
      <Sphere position={[-0.75, 0, -3]} args={[0.3]} color="#2a2a2a" />

      <Cylinder position={[0, 4, 4]} args={[0.5, 0.5, 2]} color="#2a2a2a" />
      <Cylinder position={[0, -4, 4]} args={[0.5, 0.5, 2]} color="#2a2a2a" />
    </group>
  );
};

